import { FC } from 'react';
import Constants from '../../../constants/constants';
import Dialog from '../Dialog';
import styled from 'styled-components';

const Title = styled.h2(({ theme }) => {
  const { color, type } = theme;

  return `
      font-size: ${type.size.larger};
      font-weight: ${type.weight.bold};
      color: ${color.grayscale[0]};
      margin-bottom: ${type.size.larger};
    `;
});
const BodyText = styled.p(({ theme }) => {
  const { color, type } = theme;

  return `
      font-size: ${type.size.regular};
      font-weight: ${type.weight.bold};
      color: ${color.grayscale[0]};
      line-height:2;
    `;
});

export interface IHelpDialog {
  closeCallback: () => void;
  isOpen: boolean;
}

const HelpDialog: FC<IHelpDialog> = ({ closeCallback, isOpen }) => {
  return (
    <Dialog closeCallback={closeCallback} isOpen={isOpen}>
      <Title>Have a question?</Title>
      <BodyText>
        Contact our Customer Support team directly
        <br />
        at <strong>{Constants.CS_PHONE}</strong> or{' '}
        <strong>
          <a href={`mailto:${Constants.CS_EMAIL}`}>{Constants.CS_EMAIL}</a>
        </strong>
      </BodyText>
    </Dialog>
  );
};

export default HelpDialog;
